import { createGlobalStyle } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';

const GlobalStyle = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  html, body {
    height: 100%;
  }

  body{
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    background: #f8f9fa !important;
  }

  #root {
    height: 100%;

    button::-moz-focus-inner {
      border: 0;
    }
  }

  .ant-notification {
    z-index: 1100;
  }
`;

export default GlobalStyle;
